/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

const UsersTable = ({ users, companyURL, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (users.loading) {
      return "is Loading";
    }
    if (isEmpty(users.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {users.data.map(user => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.roles.map(role => role.name).join(", ")}</td>
              <td>
                {user.roles.filter(role => role.pivot.pending === 1).length
                  ? "Pending"
                  : "Active"}
              </td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/${companyURL}/users/${user.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-exchange-alt" />
                    </span>
                    <span>Change Role</span>
                  </Link>
                  <a
                    onClick={onClickDelete(user.id)}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Remove</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};
export default UsersTable;
